module.exports = __webpack_public_path__ + "img/2x.ad82fc90.png";